// 意見要綁的錨點（#1444）。🔴 不能用訊息代號：重整後的代號來自 ai-service 配發
// 的事件代號，即時的是 AI SDK 自己產的隨機值，兩者毫無關係；連「一則」的界線都
// 不一樣。輪次是兩條路徑都算得出來的唯一穩定值。

/** 只看角色就夠：即時的 UIMessage 與重整後的投影都套得上同一條規則。 */
interface RoleOnly {
  role: string
}

// 逐則算出所屬輪次，回傳與輸入等長的陣列。規則與伺服器一致（見 turn-assembler
// 的 view.turn + 1）：一則使用者訊息開啟一輪，其後的助理內容都算同一輪。
export const messageTurns = (messages: RoleOnly[]): number[] => {
  let turn = 0
  return messages.map((message) => {
    if (message.role === 'user') turn += 1
    return turn
  })
}

// 目前進行到第幾輪。空對話是 0——與伺服器由事件流取最大值算出的結果一致；
// 真實輪次從 1 起跳，所以 0 這個值天然空著（父票 #1435 拿它代表整份對話）。
export const currentTurn = (messages: RoleOnly[]): number =>
  messages.reduce((count, message) => (message.role === 'user' ? count + 1 : count), 0)
